const projectDetailSlider = () => {
	const projectDetailThumbnailSlider = new Swiper(
		".project-detail-thumbnail .swiper",
		{
			spaceBetween: 20,
			slidesPerView: 2.5,
			observer: true,
			observeParents: true,
			slideToClickedSlide: true,
			watchSlidesVisibility: true,
			watchSlidesProgress: true,
			breakpoints: {
				768: {
					slidesPerView: 3.5,
				},
				1024: {
					slidesPerView: 4,
				},
			},
		}
	);
	const projectDetailImageSlider = new Swiper(
		".project-detail-images .swiper",
		{
			observer: true,
			observeParents: true,
			thumbs: {
				swiper: projectDetailThumbnailSlider,
			},
			on: {
				slideChange: function () {
					let activeIndex = this.activeIndex + 1;

					let nextSlide = $(
						`.project-detail-thumbnail .swiper-slide:nth-child(${
							activeIndex + 1
						})`
					);
					let prevSlide = $(
						`.project-detail-thumbnail .swiper-slide:nth-child(${
							activeIndex - 1
						})`
					);

					if (
						nextSlide &&
						!nextSlide.hasClass("swiper-slide-visible")
					) {
						this.thumbs.swiper.slideNext();
					} else if (
						prevSlide &&
						!prevSlide.hasClass("swiper-slide-visible")
					) {
						this.thumbs.swiper.slidePrev();
					}
				},
			},
		}
	);
};

projectDetailSlider();
